<template>
   <svg width="25" height="17" viewBox="0 0 25 17" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.2 7.82a1 1 0 010 1.41l-7.66 7.66-1.42-1.42 5.95-5.95H.52v-2h20.55l-5.95-5.95L16.54.16z"/>
   </svg>
</template>

<script>
export default {
   name: 'ArrowRight'
}
</script>